import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';

import { meteringPointFields } from '../../constants/meteringPoint';

export default createValidation([
  {
    name: meteringPointFields.GAS,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: meteringPointFields.CONSUMPTION_TYPE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: meteringPointFields.START_DATE,
    validators: (field) => validatorRequired()(field),
  },
]);
